export default __webpack_public_path__ + "static/media/HotWarmColdButton.f83aabde.png";